// A row with no fund/security assigned (e.g. a company-level flow) always stays visible,
// matching the Fund Ownership filter menus' handling of unassigned columns.
export const isRowInFundFilter = (row: { owner_fund?: number | null }, activeFundIds: string[]) =>
  !activeFundIds.length || row.owner_fund == null || activeFundIds.includes(String(row.owner_fund));

export const isRowInSecurityFilter = (row: { security?: number | null }, activeSecurityIds: string[]) =>
  !activeSecurityIds.length || row.security == null || activeSecurityIds.includes(String(row.security));
